@if (quantity$ | async; as quantity) { @if (visible$ | async) { @if (data$ | async; as d) {
<div
  [id]="'priceElementId' + range()"
  class="current-price"
  [ngClass]="{
    'sale-price': showInformationalPrice() && d.isListPriceGreaterThanSalePrice,
    'sale-price-higher': showInformationalPrice() && d.isListPriceLessThanSalePrice
  }"
  data-testing-id="current-price"
>
  @if (d.salePrice) {
  {{
    (d.isListPriceGreaterThanSalePrice ? 'product.price.salePricePrefix.text' : 'product.price.salePriceFallback.text')
      | translate : { '0': getTotalPrice(d.salePrice, quantity) | ishPrice }
  }}
  <meta itemprop="price" [attr.content]="d.salePrice.value | number : '1.2-2' : 'en_US'" />
  <meta itemprop="priceCurrency" [attr.content]="d.salePrice.currency" />
  } @else {
  {{ 'product.price.na.text' | translate }}
  }
</div>
@if (showInformationalPrice() && d.isListPriceGreaterThanSalePrice) {
<div class="old-price" data-testing-id="old-price">
  <span class="price-value">
    {{ 'product.price.listPriceFallback.text' | translate : { '0': getTotalPrice(d.listPrice, quantity) | ishPrice } }}
  </span>
  @if (showPriceSavings()) {
  <span class="price-savings">
    {{ 'product.price.savingsFallback.text' | translate : { '0': getTotalPrice(d.priceSavings, quantity) | ishPrice } }}
  </span>
  }
</div>
} } } }
